interface FetchWrapperProps {
  endPoint: (params: any) => Promise<any>
  params?: any
  responseFormat?: (response: any) => void
  errorFailureAction?: (error: any) => void
}

//TODO: Add finallyAction and other Actions provision

const apiWrapper = async ({
  endPoint,
  params,
  errorFailureAction,
  responseFormat,
}: FetchWrapperProps) => {
  const resultData = await endPoint(params)
    .then(async (response: any) => {
      return responseFormat ? responseFormat(response) : response
    })
    .catch((error: any) => {
      errorFailureAction && errorFailureAction(error)

      return error
    })

  return resultData
}

export default apiWrapper
